import useAjax from '@/hooks/useAjax.tsx';
import { ajaxRoutes } from '@/globalConstants.ts';
import { Routes } from '@/globalTypes.ts';
import { useForceReload } from '@keyslabor/shared/hooks/useNavigateReload.ts';

export const useLogOutMutation = () => {
  const navigate = useForceReload();

  return useAjax({
    url: ajaxRoutes.logout,
    onSuccess: () => {
      navigate(Routes.Login);
    },
  });
};
